import React, { useEffect, useState } from 'react';
import { cn } from '@/lib/utils';
export const CTAButton = ({
  children,
  href = 'https://mundial-en-el-aula-megapack-primaria.impultienda.ar/checkout',
  className = '',
  variant = 'primary'
}: {
  children: React.ReactNode;
  href?: string;
  className?: string;
  variant?: 'primary' | 'outline';
}) => {
  const handleClick = () => {
    if (typeof window !== 'undefined' && (window as any).fbq && href.includes('checkout')) {
      ;
      (window as any).fbq('track', 'InitiateCheckout', {
        content_name: 'Mundial en el Aula 360 Mega Pack',
        content_category: 'Education',
        currency: 'ARS',
        value: 16990
      });
    }
  };
  return <a href={href} onClick={handleClick} className={cn(`inline-flex items-center justify-center px-8 py-4 rounded-lg font-bold uppercase transition-all duration-300 text-center cta-shadow cta-animated ${variant === 'primary' ? 'bg-familia-green text-white hover:bg-familia-greenHover' : 'border-2 border-familia-electric text-familia-electric hover:bg-familia-electric/10'} ${className}`, 'text-[12px] mt-[-10px] mb-[-10px]', 'pt-[16px] pb-[16px]')} data-id="element-209">
      {children}
    </a>;
};
export const Countdown = ({
  className = ''
}: {
  className?: string;
}) => {
  const [timeLeft, setTimeLeft] = useState({
    h: 23,
    m: 54,
    s: 1
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.s > 0) return {
          ...prev,
          s: prev.s - 1
        };
        if (prev.m > 0) return {
          ...prev,
          m: prev.m - 1,
          s: 59
        };
        if (prev.h > 0) return {
          h: prev.h - 1,
          m: 59,
          s: 59
        };
        return {
          h: 23,
          m: 59,
          s: 59
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const format = (n: number) => n.toString().padStart(2, '0');
  return <div className={`flex justify-center items-start gap-2 sm:gap-4 font-mono text-2xl sm:text-4xl md:text-6xl font-bold text-familia-red w-full ${className}`} data-id="element-210">
      <div className="flex flex-col items-center" data-id="element-211">
        <div className="bg-familia-card border border-familia-red/30 px-3 py-2 sm:p-3 rounded-lg min-w-[60px] sm:min-w-[80px] text-center text-white" data-id="element-212">
          [{format(timeLeft.h)}]
        </div>
        <span className="text-[10px] sm:text-xs text-familia-gray mt-2 uppercase font-sans" data-id="element-213">
          horas
        </span>
      </div>
      <div className="pt-2 sm:pt-4 text-familia-red" data-id="element-214">:</div>
      <div className="flex flex-col items-center" data-id="element-215">
        <div className="bg-familia-card border border-familia-red/30 px-3 py-2 sm:p-3 rounded-lg min-w-[60px] sm:min-w-[80px] text-center text-white" data-id="element-216">
          [{format(timeLeft.m)}]
        </div>
        <span className="text-[10px] sm:text-xs text-familia-gray mt-2 uppercase font-sans" data-id="element-217">
          minutos
        </span>
      </div>
      <div className="pt-2 sm:pt-4 text-familia-red" data-id="element-218">:</div>
      <div className="flex flex-col items-center" data-id="element-219">
        <div className="bg-familia-card border border-familia-red/30 px-3 py-2 sm:p-3 rounded-lg min-w-[60px] sm:min-w-[80px] text-center text-white" data-id="element-220">
          [{format(timeLeft.s)}]
        </div>
        <span className="text-[10px] sm:text-xs text-familia-gray mt-2 uppercase font-sans" data-id="element-221">
          segundos
        </span>
      </div>
    </div>;
};
export const PriceCard = () => {
  const items = ['Planificación de 1.º a 7.º grado', 'Lengua, Matemática, Geografía y Ciencias', 'Estadística, probabilidad y evaluación', 'Recursos imprimibles', 'Cuatro bonos incluidos', 'Acceso inmediato', 'Pago único', 'Acceso de por vida'];
  return <div className="bg-familia-section border-2 border-familia-gold rounded-2xl p-5 sm:p-8 shadow-[0_0_30px_-12px_rgba(215,168,62,0.5)] max-w-2xl mx-auto relative overflow-hidden" data-id="element-222">
      <div className="absolute top-0 left-1/2 -translate-x-1/2 bg-familia-gold text-familia-bg font-bold text-xs py-1 px-4 rounded-b-lg uppercase whitespace-nowrap" data-id="element-223">
        ⭐ MUNDIAL EN EL AULA 360™
      </div>
      <div className="text-center mt-4 mb-6" data-id="element-224">
        <p className="text-familia-gray text-xs uppercase tracking-widest font-bold" data-id="element-225">
          Mega Pack Primaria · De 1.º a 7.º grado.
        </p>
      </div>

      <div className="flex flex-col items-center gap-1 mb-6 bg-familia-card/60 p-5 rounded-xl border border-white/5" data-id="element-226">
        <div className="text-familia-gray text-xs mb-1 text-center" data-id="element-227">
          <p data-id="element-228">Valor del producto: AR$ 84.950</p>
          <p data-id="element-229">Valor de los bonos: AR$ 45.960</p>
        </div>
        <div className="flex flex-col items-center" data-id="element-230">
          <span className="text-familia-red line-through text-lg mb-1 font-bold" data-id="element-231">
            AR$ 130.910
          </span>
          <span className="text-familia-green text-4xl sm:text-5xl font-display font-bold mb-2" data-id="element-232">
            HOY AR$ 16.990
          </span>
          <span className="bg-familia-electric text-white text-xs font-bold px-3 py-1 rounded-full uppercase" data-id="element-233">
            Ahorrás AR$ 113.920 — 87% OFF
          </span>
        </div>
      </div>

      <CTAButton href="https://mundial-en-el-aula-megapack-primaria.impultienda.ar/checkout" className="w-full text-base sm:text-lg py-4 mb-4" data-id="element-234">
        QUIERO MUNDIAL EN EL AULA 360™
      </CTAButton>

      <div className="mb-5 text-center" data-id="element-235">
        <div className="flex justify-center items-center gap-3 mb-2 opacity-80 grayscale hover:grayscale-0 transition-all duration-300 pt-[15px] pb-[15px]" data-id="element-236">
          <span className="bg-white px-1.5 py-0.5 rounded text-[10px] font-bold text-blue-800 border border-gray-200" data-id="element-237">
            VISA
          </span>
          <span className="bg-white px-1.5 py-0.5 rounded text-[10px] font-bold text-red-600 border border-gray-200" data-id="element-238">
            MASTER
          </span>
          <span className="bg-white px-1.5 py-0.5 rounded text-[10px] font-bold text-blue-500 border border-gray-200" data-id="element-239">
            MP
          </span>
          <span className="bg-white px-1.5 py-0.5 rounded text-[10px] font-bold text-gray-700 border border-gray-200" data-id="element-240">
            TRANSFERENCIA
          </span>
        </div>
      </div>

      <div className="flex flex-wrap justify-center gap-3 text-[10px] sm:text-xs text-familia-gray mb-6 font-semibold" data-id="element-241">
        <span className="flex items-center gap-1" data-id="element-242">🔒 Pago seguro</span>
        <span className="flex items-center gap-1" data-id="element-243">⚡ Entrega inmediata</span>
        <span className="flex items-center gap-1" data-id="element-244">🛡️ Garantía de 7 días</span>
        <span className="flex items-center gap-1" data-id="element-245">🖨️ Listo para imprimir</span>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-y-2 gap-x-4 border-t border-white/10 pt-6 text-left" data-id="element-246">
        {items.map((item, i) => <div key={i} className="flex items-start gap-2" data-id="element-247">
            <span className="text-familia-green text-base shrink-0" data-id="element-248">✅</span>
            <span className="text-xs sm:text-sm font-medium text-white/90" data-id="element-249">
              {item}
            </span>
          </div>)}
      </div>
    </div>;
};